import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Dialog, DialogContent, Typography } from '@mui/material'

import GRDialogTitle from '../../../../../components/GRDialogTitle/GRDialogTitle'
import { formatReleaseDate } from '../../helpers/dashboardHelpers'
import { DashboardVersion } from '../../types/Dashboard'

type ReleaseNotesDialogProps = {
  version?: DashboardVersion
  onClose: () => void
}

export const ReleaseNotesDialog: FC<ReleaseNotesDialogProps> = ({ version, onClose }) => {
  const { t } = useTranslation()
  return (
    <Dialog open={!!version} onClose={onClose} fullWidth maxWidth="sm">
      <GRDialogTitle onClose={onClose}>{version?.version}</GRDialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" fontWeight="bold" mb={1}>
          {t('internal-analysts:dashboard_release_date', { date: formatReleaseDate(version?.versionReleaseDate) || '---' })}
        </Typography>
        <Typography whiteSpace="pre-line">{version?.releaseNotes || t('internal-analysts:dashboard_release_notes_none')}</Typography>
      </DialogContent>
    </Dialog>
  )
}
